import styled, { css } from "styled-components";

export const Spinner = styled.div`
	border-radius: 50%;
	border: 3px solid;
	border-color: var(--border-color-light);
	width: 24px;
	height: 24px;
	animation: spin 1s linear infinite;
	margin-left: 6px;
	${(props) =>
		props.darkBg &&
		css`
			border-color: var(--border-color-dark);
		`}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;

export const SpinnerWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;
